<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div v-if="isNew && isNew == true" class="margin-left-l font-s">插入试题</div>
                <div v-else class="margin-left-l font-s">编辑试题</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <vue-custom-scrollbar class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">题号</div>
                            <div class="value"> <input placeholder="从1开始编号"  class="ui-input full-width" type="text" v-model="formData.index" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m font-m">
                            <div class="label">题目</div>
                            <div class="value"> <textarea placeholder="填写题目内容"  style="height: 50px;" class="ui-input full-width"  v-model="formData.title" ></textarea>   </div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">选项A</div>
                            <div class="value"> <input placeholder="填写选项A内容"  class="ui-input full-width" type="text" v-model="formData.optionA" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">选项B</div>
                            <div class="value"> <input placeholder="填写选项B内容" class="ui-input full-width" type="text" v-model="formData.optionB" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">选项C</div>
                            <div class="value"> <input placeholder="填写选项C内容" class="ui-input full-width" type="text" v-model="formData.optionC" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">选项D</div>
                            <div class="value"> <input placeholder="填写选项D内容" class="ui-input full-width" type="text" v-model="formData.optionD" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">答案</div>
                            <div class="value"><x-select class='ui-xselect' v-model="formData.result"  :data="resultData"  ></x-select> </div>
                        </div>

                </div>
            </vue-custom-scrollbar>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box"> 
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>         
            </div>
        </div>
    </div>
</template>

<script>
    import MySelect from '@/components/select/Select' 
    import {getQuestionData} from '@/api/api.js';   
    import { objToStr } from '../../utils/sysUtils';
    import XSelect from '@/components/xSelect/XSelect.vue';
   

    export default {
        name:'insertQuestionModal',
        created() {
        },
        components:{MySelect,XSelect},
        data() {
            return {
                show: null,
                isNew: false,
                formData:{},
                resultData:[
                    {
                        text:"A",
                        value:'A',
                    },
                    {
                        text:"B",
                        value:'B',
                    },
                    {
                        text:"C",
                        value:"C",
                    },
                    {
                        text:"D",
                        value:"D",
                    },
                    {
                        text:"输入",
                        value:"X",
                    },

                ],
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),

            }
        },
        methods:{
            showForm(data) {
                this.isNew = false;
                this.$showLoading();
                getQuestionData(data.dataId).then((res) => {
                    if (res.data.success == true) {
                        this.formData = res.data.result;
                        this.formData.result = this.formData.result.split(",")
                        this.show = true;
                        this.$closeLoading(); 

                    }             
                })         
            },
            newForm(data) {
                this.formData = data;
                this.isNew = true;
                this.show = true;
            },
            confirm() {
                console.log(this.formData);

                if (objToStr(this.formData.index) ==="") {
                    this.$showToast({
                        msg: '题号未填写' 
                    }) 
                    return false;
                }

                if (objToStr(this.formData.title) ==="") {
                    this.$showToast({
                        msg: '题目内容未填写' 
                    }) 
                    return false;
                }

                if (objToStr(this.formData.optionA) ==="") {
                    this.formData.optionA = "-"
                }
                if (objToStr(this.formData.optionB) ==="") {
                    this.formData.optionB = "-"
                }
                if (objToStr(this.formData.optionC) ==="") {
                    this.formData.optionC = "-"
                }
                if (objToStr(this.formData.optionD) ==="") {
                    this.formData.optionD = "-"
                }
                if (Array.isArray(this.formData.result)) {
                    this.formData.result = this.formData.result.join(",")
                }

                if (this.isNew) {
                    this.$emit("add", this.formData)
                } else {
                    this.$emit("update", this.formData)
                }
                
            },
            close() {
                this.show = false;
            },
            
            

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 100px;
    }
    .doc-edit-modal {
        width: 650px;
        height: 550px;
    }
    .edit-area {
       width: 600px;
    }
 

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/plugs/InsertQuestionModal.vue